
import { getKeyFromUrl } from './util/url';

export function reportUrl({ statUrl = '', action = '', subkey = '', qbst = '', stsource = '', sturl = '', qt = '' }) {
    const url = `${statUrl}&action=${action}&subkey=${subkey}&qbst=${qbst || getKeyFromUrl('st')}&stsource=${stsource || getKeyFromUrl('stsource')}&sturl=${encodeURIComponent(sturl || getKeyFromUrl('sturl'))}&qt=${qt}&r=${Date.now()}`;
    new Image().src = url;
}


